import { useRef } from "react";
import Slider from "react-slick";
import Icons from "../../myIcon/Icons";

export default function ServiceDetailRange() {
    const sliderRef1 = useRef(null); 
    const sliderRef2 = useRef(null); 

    const settings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 1400,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        pauseOnHover: false,
        cssEase: "ease",
    };

    const handlePrev = () => {
        sliderRef1.current?.slickPrev();
        sliderRef2.current?.slickPrev();
    };

    const handleNext = () => {
        sliderRef1.current?.slickNext();
        sliderRef2.current?.slickNext();
    };

    const CustomArrows = () => (
        <>
        <div className="default-arrowleft" onClick={handlePrev}>
            <Icons name="Longarrow_left" />
        </div>
        <div className="default-arrowright" onClick={handleNext}>
            <Icons name="Longarrow_right" />
        </div>
        </>
    );

  return (
    <>
    <section className="detailserv-range">
        <div className="container">
            <div className="row"> 

                <div className="col-lg-4 col-md-4">
                    <div className="servrange-detail">
                        <span>Range</span>
                        <h3 className="heading">Tailored modular kitchens and wardrobes</h3>
                        <p>From private residences and modern apartments to luxury workspaces - each project receives a modular strategy that respects the space’s soul and use.</p>
                    </div>
                </div>

                <div className="col-lg-6 col-md-6">
                    <Slider {...settings} ref={sliderRef1}>
                        <img src="/image/modular-slide-1.webp" className="img-responsive" alt="range"/>
                        <img src="/image/modular-slide-2.webp" className="img-responsive" alt="range"/>
                    </Slider>
                </div>

                <div className="col-lg-2 col-md-2">
                    <div className="servrange-arrow">
                        <div className="inner-servrange">
                            <Slider {...settings} ref={sliderRef2}>
                                <p>Private residence</p>
                                <p>Commercial spaces</p>
                            </Slider>
                            <CustomArrows />
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </section>  
    </>
  )
}
